/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px;
  gap: 30px;
  overflow: auto;
`;
Wrapper.displayName = 'Wrapper';

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
Fields.displayName = 'Fields';
